import { render } from "./AiImportListComponent.vue?vue&type=template&id=b38c6ca6"
import script from "./AiImportListComponent.vue?vue&type=script&lang=js"
export * from "./AiImportListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/products/ai-import/AiImportListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b38c6ca6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b38c6ca6', __exports__)) {
    api.reload('b38c6ca6', __exports__)
  }
  
  module.hot.accept("./AiImportListComponent.vue?vue&type=template&id=b38c6ca6", () => {
    api.rerender('b38c6ca6', render)
  })

}


export default __exports__